export const createFlawsRequests = (client) => ({
    listFlaws: async (params) => {
        const { data, meta, links } = await client.api.get("flaws", {
            params: params,
        });
        return { data, meta, links };
    },
    findFlaw: async (params) => {
        const { data, meta, links } = await client.api.get(`flaws/${params?.filter?.id}`, {
            params: params,
        });
        return { data, meta, links };
    },
});
//# sourceMappingURL=index.js.map